import React from 'react'

function Error() {
	return <div>Hi! Are you lost?</div>
}

export default Error
